import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
import { spacing } from '../constants/spacing.js';

var contentSwitcherThemeNative = {
  color: 'primary',
  active: {
    textColor: 'background',
    backgroundColor: 'primary'
  },
  inactive: {
    textColor: 'text',
    backgroundColor: 'background'
  }
};
var contentSwitcherThemeWeb = {
  color: 'primary',
  borders: {
    radius: 'borders.radius'
  },
  disabled: {
    background: colors.cloudGrey,
    font: colors.fogGrey
  },
  active: {
    borderColor: 'primary'
  },
  inactive: {
    textColor: 'text',
    background: 'background',
    borderColor: 'primary'
  },

  /**
   * Button horizontal paddings
   */
  paddings: {
    /**
     * Below breakpoint m
     */
    "default": spacing.m,

    /**
     * At breakpoint m and above
     */
    m: spacing.m
  }
};
var contentSwitcherDarkThemeWeb = _extends({}, contentSwitcherThemeWeb, {
  disabled: _extends({}, contentSwitcherThemeWeb.disabled, {
    background: colors.inkGrey,
    font: colors.octoberGrey
  })
});

export { contentSwitcherDarkThemeWeb, contentSwitcherThemeNative, contentSwitcherThemeWeb };
